<template>
  <div class="partner-tab-sharing-level-placeholder-cell">
    <span v-if="label" class="text-sm text-neutral-text">{{ label }}</span>
    <span v-else class="text-sm text-neutral-text-weak">&ndash;</span>
  </div>
</template>

<script setup lang="ts">
import { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';

import {
  GREENFIELD_SHARING,
  HIDDEN,
  OLAPS_ONLY,
  SHARING,
  type SharingType,
} from '@/constants/data_shares';
import type { SegmentType } from '@/types/populations';

import type { SharingPartnerRow } from '../types';

const { params } = defineProps<{
  params: ICellRendererParams<SharingPartnerRow> & {
    segmentKey: SegmentType;
    side: 'incoming' | 'outgoing';
  };
}>();

/**
 * Deliberately unstyled. PGA-534 replaces this with the real SharingLevelCell,
 * which carries the six colour variants; colouring them here would mean
 * shipping a guess that has to be unpicked.
 */
const SHARING_LEVEL_LABEL: Record<SharingType, string> = {
  [GREENFIELD_SHARING]: 'All',
  [SHARING]: 'Overlaps',
  [OLAPS_ONLY]: 'Counts',
  [HIDDEN]: 'Hidden',
};

const label = computed(() => {
  const visibility = params.data?.[params.side][params.segmentKey];
  return visibility ? SHARING_LEVEL_LABEL[visibility] : null;
});
</script>

<style lang="pcss">
@reference "../../../../css/theme.css";
.partner-tab-sharing-level-placeholder-cell {
  @apply flex items-center justify-center h-full w-full;
}
</style>
